<div *ngIf="confirmation" class="dialog-overlay" [@fade]>
  <div class="dialog" [@popup]="false">
    <div *ngIf="!confirmation?.hasSuccessGraphic && !confirmation?.graphicUrl; else graphicTemplate" class="title">
      {{ confirmation.title }}
      <hfc-button icon="close" (click)="onRejectClicked()"></hfc-button>
    </div>
    <ng-template #graphicTemplate>
      <div
        class="success-graphic"
        [style.background-image]="confirmation.graphicUrl ? 'url(' + confirmation.graphicUrl + ')' : null"
      >
        <hfc-button icon="close" (click)="onRejectClicked()"></hfc-button>
        <div class="title">
          {{ confirmation.title }}
        </div>
      </div>
    </ng-template>

    <div class="message" [innerHTML]="confirmation.message | sanitizeHtml"></div>

    <div class="note-input" *ngIf="confirmation.noteInputLabel">
      <div class="note-label">{{ confirmation.noteInputLabel }}</div>
      <hfc-textarea-input [(ngModel)]="noteValue" [rows]="3"></hfc-textarea-input>
    </div>

    <div class="secondary-content" *ngIf="confirmation.secondaryTitle || confirmation.secondaryMessage">
      <div *ngIf="confirmation.secondaryTitle" class="title">
        {{ confirmation.secondaryTitle }}
      </div>
      <div *ngIf="confirmation.secondaryMessage" class="content">
        <span>{{ confirmation.secondaryMessage }}</span>
      </div>
    </div>

    <div class="buttons">
      <hfc-button
        [type]="confirmation.acceptButtonType"
        [size]="'normal'"
        [isLoading]="isAcceptButtonLoading"
        (click)="onAcceptClicked()"
      >{{ confirmation.acceptLabel }}
      </hfc-button>
      <hfc-button
        [size]="'normal'"
        type="transparent"
        *ngIf="confirmation.secondaryAction && !confirmation.rejectButtonType"
        (click)="onSecondaryActionClicked()"
      >{{ confirmation.secondaryAction.label }}
      </hfc-button>
      <hfc-button
        *ngIf="confirmation.rejectButtonType"
        [size]="'normal'"
        [type]="'grey'"
        (click)="onRejectClicked()"
      >{{ confirmation.rejectLabel }}
      </hfc-button>
    </div>
  </div>
</div>
